import { io } from "socket.io-client";
import { getBackendUrl } from "../config";

function connectToSocket() {
    const rawToken = localStorage.getItem("token");

    let token = "";
    if (rawToken) {
      try {
        token = JSON.parse(rawToken);
      } catch {
        token = rawToken;
      }
    }

    const socketUrl = new URL(getBackendUrl()).origin;
    return io(socketUrl, {
      transports: ["websocket", "polling"],
      query: { token },
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 500,
    });
}

export default connectToSocket;